<template>
  <w-icon-wrapper
    :height='24'
    :width='18'
    icon-name='work-favorite-filled-icon'
    view-box='0 0 18 24'
  >
    <path
      id='_72_Favoriten_Filled'
      d='M21.5.39v24l-9-7-9,7V.39Z'
      data-name='72 Favoriten_Filled'
      fill='currentColor'
      transform='translate(-3.5 -0.39)'
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconFavoriteFilled' };
</script>
